import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

import InitialEvaluation from "../components/forms/InitialEvaluation";
import { useAuth } from "../context/AuthContext";

const OnboardingRoute = () => {
  const navigate = useNavigate();
  const { pendingEvaluationAthleteId, athleteData, completeOnboarding } =
    useAuth();

  const athleteId = pendingEvaluationAthleteId || athleteData?.id;

  if (!athleteId) {
    return <Navigate to="/athlete/dashboard" replace />;
  }

  return (
    <InitialEvaluation
      athleteId={athleteId}
      onComplete={async () => {
        await completeOnboarding();
        navigate("/athlete/dashboard", { replace: true });
      }}
    />
  );
};

export default OnboardingRoute;
